function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: ",
        ";\n  height: ",
        ";\n  display: flex;\n  justify-content: ",
        ";\n  align-items: center;\n\n  .skeleton-loading {\n    padding: 0;\n    justify-content: flex-end;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      margin-left: auto;\n    "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  width: ",
        ";\n  animation: skeleton-loading 1s linear infinite alternate;\n  background-color: ",
        ";\n  border-radius: 4px;\n\n  ",
        ";\n\n  @keyframes skeleton-loading {\n    0% {\n      background-color: hsl(200, 0%, 90%);\n    }\n    100% {\n      background-color: hsl(200, 0%, 70%);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { ClipLoader } from 'react-spinners';
import { Flex } from '@dutchie/common/components/rebass-compat';
export function FullPageLoader(param) {
    var _param_color = param.color, color = _param_color === void 0 ? '#61a58b' : _param_color;
    return /*#__PURE__*/ _jsx(Flex, {
        justifyContent: "center",
        alignItems: "center",
        style: {
            height: '50vh',
            minHeight: '700px'
        },
        children: /*#__PURE__*/ _jsx(ClipLoader, {
            color: color,
            size: 100
        })
    });
}
/**
 * @type {JSX.Element}
 *
 */ export function SmallLoader(_param) {
    var _param_spinnerSize = _param.spinnerSize, spinnerSize = _param_spinnerSize === void 0 ? null : _param_spinnerSize, _param_height = _param.height, height = _param_height === void 0 ? 60 : _param_height, _param_width = _param.width, width = _param_width === void 0 ? null : _param_width, _param_color = _param.color, color = _param_color === void 0 ? '#61a58b' : _param_color, props = _object_without_properties(_param, [
        "spinnerSize",
        "height",
        "width",
        "color"
    ]);
    return /*#__PURE__*/ _jsx(Container, _object_spread_props(_object_spread({
        height: height,
        width: width
    }, props), {
        children: /*#__PURE__*/ _jsx(ClipLoader, {
            color: color,
            size: spinnerSize || height
        })
    }));
}
/**
 * @param {Object} props - Component props
 * @param {number} [props.height=60] - Height of the skeleton in pixels
 * @param {number|null} [props.width=null] - Width of the skeleton in pixels. If null, defaults to 100%
 * @param {boolean} [props.isLeftAligned=false] - Whether to align the skeleton to the left
 * @param {boolean} [props.useExactDimensions=false] - Whether to use the exact dimensions of the skeleton
 * @param {Object} [props...rest] - Additional props are spread to the container element
 * @returns {JSX.Element} A skeleton loader component with animation
 */ export function SkeletonLoader(_param) {
    var _param_height = _param.height, height = _param_height === void 0 ? 60 : _param_height, _param_width = _param.width, width = _param_width === void 0 ? null : _param_width, _param_isLeftAligned = _param.isLeftAligned, isLeftAligned = _param_isLeftAligned === void 0 ? false : _param_isLeftAligned, _param_useExactDimensions = _param.useExactDimensions, useExactDimensions = _param_useExactDimensions === void 0 ? false : _param_useExactDimensions, props = _object_without_properties(_param, [
        "height",
        "width",
        "isLeftAligned",
        "useExactDimensions"
    ]);
    return /*#__PURE__*/ _jsx(Container, _object_spread_props(_object_spread({
        className: "skeleton-loading",
        height: height,
        width: width,
        $isLeftAligned: isLeftAligned,
        $useExactDimensions: useExactDimensions
    }, props), {
        children: /*#__PURE__*/ _jsx(Skeleton, {
            $isLeftAligned: isLeftAligned,
            $useExactDimensions: useExactDimensions
        })
    }));
}
var Container = styled(Flex)(_templateObject(), function(param) {
    var width = param.width;
    return width ? "".concat(width, "px") : '100%';
}, function(param) {
    var height = param.height, $useExactDimensions = param.$useExactDimensions;
    return $useExactDimensions ? "".concat(height, "px") : "".concat(height - 10, "px");
}, function(param) {
    var $isLeftAligned = param.$isLeftAligned;
    return $isLeftAligned ? 'flex-start' : 'center';
});
var Skeleton = styled.div(_templateObject2(), function(param) {
    var $useExactDimensions = param.$useExactDimensions;
    return $useExactDimensions ? '100%' : '75%';
}, function(param) {
    var $useExactDimensions = param.$useExactDimensions;
    return $useExactDimensions ? '100%' : '50%';
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey[95];
}, function(param) {
    var $isLeftAligned = param.$isLeftAligned;
    return !$isLeftAligned && css(_templateObject1());
});
